import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const YourBudgetFilter = () => {
  const [minVal, setMinVal] = useState(400);
  const [maxVal, setMaxVal] = useState(5000);
  const { t } = useTranslation();

  // Update display when slider changes
  const handleMinChange = (e) => {
    let value = parseInt(e.target.value);
    if (value > maxVal) {
      setMaxVal(value);
      setMinVal(maxVal);
    } else {
      setMinVal(value);
    }
  };

  const handleMaxChange = (e) => {
    let value = parseInt(e.target.value);
    if (value < minVal) {
      setMinVal(value);
      setMaxVal(minVal);
    } else {
      setMaxVal(value);
    }
  };

  return (
    <div className="list-trip">
      <div className="budget-container">
        <h4>{t("budgetTitle")}</h4>
        <p className="mb-2 p-0">
          ₹ {minVal.toLocaleString()} – ₹ {maxVal.toLocaleString()}+
        </p>

        <div className="slider-container position-relative">
          <input
            type="range"
            min="400"
            max="5000"
            value={minVal}
            step="100"
            onChange={handleMinChange}
          />
          <input
            type="range"
            min="400"
            max="5000"
            value={maxVal}
            step="100"
            onChange={handleMaxChange}
          />
        </div>
      </div>
    </div>
  );
};

export default YourBudgetFilter;
